import React from 'react'
import * as d3 from "../d3.modified.js"

export default class CategoryNode extends React.PureComponent {
    constructor(props) {
        super(props)
        this.props.nodeItem.refs = {}
        this.props.nodeItem._jsx = {
            styleSelect: this.styleSelect,
            styleDeselect: this.styleDeselect,
            styleMove: this.styleMove,
            styleFade: this.styleFade
        }
        this.props.nodeItem.height = 70
    }

    componentDidMount() {
        this.postModifiers()

        var node = this.props.nodeItem

        if (node._selectionId!==-1) {
            this.styleSelect()
        }

        this.position = undefined;

        const _step = 10

        node.refs.holder
            .transition()
                .duration(500)
                .style('opacity', 1)

        node.refs.holder.call(d3.drag()
            .on('start', ()=>{
                this.position = {x:d3.event.x, y:d3.event.y}
                this.props.hideCtxMenus()

                // <grided>
                this.startDragMPosX = d3.event.x
                this.startDragMPosY = d3.event.y
                this.startDragPosX = node.x
                this.startDragPosY = node.y
                // </grided>

                this.props.dragStartHandler()
            })
            .on('drag', ()=>{
                node.refs.holder.classed('moving', true)
                if (node._selectionId === -1) {
                    this.props.clickHandler(node, true)
                }
                if ((!this.props.keyPressDict.link || (this.props.keyPressDict.link && node._selectionId!==-1)) && (!this.props.keyPressDict.ctrl || node._selectionId !== -1)) {
                    // <grided>
                    if (this.props.keyPressDict.grid) {
                        let x = this.startDragPosX + (d3.event.x-this.startDragMPosX)-node.width*0.5
                        let y = this.startDragPosY + (d3.event.y-this.startDragMPosY)-node.height*0.5
                        x = parseInt((x+_step/2)/_step)*_step
                        y = parseInt((y+_step/2)/_step)*_step

                        let dx = x-node.x+node.width*0.5
                        let dy = y-node.y+node.height*0.5
                        this.props.dragHandler(dx, dy)
                    } else {
                    // </grided>
                        this.props.dragHandler(d3.event.dx, d3.event.dy)
                    }
                }
            })
            .on('end', ()=>{
                node.refs.holder.classed('moving', false)
                let newPosition = {x:d3.event.x, y:d3.event.y}
                if ((newPosition.x !== this.position.x) || (newPosition.y !== this.position.y) ) {
                    this.props.dragEndHandler()
                }
            })
        )

        node.refs.holder
            .on('mouseenter', ()=>{
                if (this.props.keyPressDict.link) {
                    if (this.props.canCreateLink(node)) {
                        node.refs.holder.classed('linkage-can', true)
                    } else {
                        node.refs.holder.classed('linkage-cannot', true)
                    }
                }
            })
            .on('mouseleave', ()=>{
                if (this.props.keyPressDict.link) {
                    node.refs.holder.classed('linkage-can', false)
                    node.refs.holder.classed('linkage-cannot', false)
                }
            })

        node.refs.holder
            .on("click", ()=>{
                if (this.props.keyPressDict.link) {
                    this.props.createLink(node)
                } else {
                    this.props.clickHandler(node)
                }
                d3.event.stopPropagation()
            })
    }

    postModifiers = () => {
        var node = this.props.nodeItem

        var hasDesc = (node.properties.description!=='')

        var bb1 = node.refs.name.getBBox()
        var bb2 = hasDesc ? node.refs.description.getBBox() : {width:0}
        var maxW = bb1.width
        maxW = (maxW < bb2.width ? bb2.width : maxW)

        node.height = hasDesc ? 70 : 30
        node.width = maxW

        var _ = (a,b,c) => {this.props.enqueueAttrChange({elem:a,attr:b,val:c})}
        _(node.refs.background, 'width', node.width+30)
        _(node.refs.background, 'height', node.height)
        _(node.refs.background, 'x', -node.width/2-15)
        _(node.refs.background, 'y', -node.height/2)
        if (hasDesc) {
            _(d3.select(node.refs.name), 'y', -5)
        } else {
            _(d3.select(node.refs.name), 'y', 5)
        }

    }

    componentDidUpdate() {
        this.postModifiers()
    }

    styleMove = () => {
        var node = this.props.nodeItem
        this.props.enqueueAttrChange({
            elem: node.refs.holder,
            attr: 'transform',
            val: `translate(${node.x} ${node.y})`
        })
    }

    styleSelect = () => {
        var node = this.props.nodeItem
        this.props.enqueueClassChange({
            elem: node.refs.holder,
            class: 'active',
            val: true,
        })
    }

    styleDeselect = () => {
        var node = this.props.nodeItem
        this.props.enqueueClassChange({
            elem: node.refs.holder,
            class: 'active',
            val: false,
        })
    }

    styleFade = () => {
        this.props.nodeItem.refs.holder
            .transition()
                .duration(400)
                .style('opacity', 0)
    }

    render() {
        var node = this.props.nodeItem

        const diffColors = {
            none: "#fff",
            yellow: "#FFFFE6",
            green: "#E6FFED",
            red: "#FFEEF0"
        }

        return (
            <g
                className="node-holder node-category-holder"
                transform={`translate(${node.x} ${node.y})`}
                ref={c=>node.refs.holder=d3.select(c)}
                opacity="0"
            >
            {/* BACKGROUND */}
                <rect
                    className="node-category-background"
                    id={`N_${node.id}`}
                    width={`${node.width}px`}
                    height={`${node.height}px`}
                    rx="50"
                    ry="50"
                    ref={c=>node.refs.background=d3.select(c)}
                    x={-node.width/2}
                    y={-node.height/2}
                    style={{fill: node._compareType?diffColors[node._compareType]:'#fdfdfd'}}
                />
            {/* FIELDS */}
                <text
                    x="0"
                    y="-10"
                    className="node-category-name"
                    textAnchor="middle"
                    alignmentBaseline="baseline"
                    ref={c=>node.refs.name=c}
                    style={{fill: node._compareType?'#444':node.properties.color}}
                >{(!node.properties.title || node.properties.title===''?'(untitled node)':node.properties.title)}</text>
                {
                    (node.properties.description!=='')
                        ? <text x="0" y="12" className="node-category-description" textAnchor="middle" alignmentBaseline="baseline" ref={c=>node.refs.description=c}>{node.properties.description}</text>
                        : null
                }

            </g>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/nodes/CategoryNode.js